<template>
  <div>
    <d-card class="card-small mb-4 pt-3">
      <d-card-body flush class="text-center pt-0">
        <!-- User Name -->
        <h4 class="mb-0" style="font-weight: 500">
          {{ userDetails.firstName }} {{ userDetails.lastName }}
        </h4>

        <!-- User Job Title -->
        <span class="text-muted d-block mb-2">{{ userDetails.email }}</span>
      </d-card-body>
    </d-card>

    <d-card class="card-small mb-4 pt-3">
      <d-card-header class="p-0 pl-3 pb-3 border-bottom">
        <h6 class="m-0">Groupes</h6>
      </d-card-header>
      <d-card-body>
        <d-container fluid>
          <!-- Teams List -->
          <d-row v-for="(team, idx) in teams" :key="idx" class="mb-3">
            <d-col lg="12" sm="1" class="user-teams__image my-auto p-0">
              <div
                class="group-info-small"
                :style="{
                  backgroundColor: team.color,
                  color: team.txtColor ? team.txtColor : '#6f6f6f',
                }"
              >
                {{ team.name.substring(0, 1) }}
              </div>
            </d-col>
            <d-col class="user-teams__info pl-3 d-flex align-self-center">
              <h6 class="m-0">{{ team.name }}</h6>
            </d-col>
          </d-row>
        </d-container>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
import groups from '@/data/groups/Groups';

export default {
  name: 'user-details',
  props: {
    userDetails: {
      type: Object,
    },
    editable: Boolean,
  },
  computed: {
    teams() {
      const teams = [];
      this.userDetails.permissions.forEach((group) => {
        teams.push(groups.find(el => el.reference === group.groupReference));
      });
      return teams;
    },
  },
  methods: {
    uploadAvatar($event) {
      $event.preventDefault();
      const file = this.$refs.upload.files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'avatar');
      formData.append('reference', this.userDetails.reference);
      this.$services.user.myAvatar(formData).then(({ data }) => {
        this.$emit('updateProfile', data);
      });
    },
  },
};
</script>

<style>
.group-info-small {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 700;
  border-radius: 10px;
}
</style>
